import clsx from "clsx";

import type { ReactNode } from "react";

export default function LeadSectionContainer({
  title,
  children,
  isColumn,
  hasBorder,
}: {
  title: string;
  children: ReactNode;
  isColumn: boolean;
  hasBorder: boolean;
}) {
  return (
    <div
      className={clsx(
        "flex px-4",
        isColumn
          ? "flex-col gap-y-2.5 pb-2.5 pt-2"
          : "py-2 gap-x-2.5 justify-between items-center",
        hasBorder && "border-b border-b-black-200",
      )}
    >
      <span className="text-button-sm">{title}</span>
      {children}
    </div>
  );
}
